/**
 * Registro Central de Rutas
 * 
 * Este archivo centraliza todas las rutas de la aplicación.
 * Para agregar una nueva ruta:
 * 1. Agregar la ruta en el archivo correspondiente del módulo (production.jsx, quality.jsx, etc.)
 * 2. Importar y agregar aquí en el array correspondiente
 * 
 * ESTRUCTURA:
 * - publicRoutes: Rutas públicas (no requieren autenticación)
 * - generalRoutes: Rutas generales protegidas (dashboard, profile)
 * - productionRoutes: Rutas de producción
 * - qualityRoutes: Rutas de calidad (con permisos específicos)
 * - personasRoutes: Rutas de personas
 * - processesRoutes: Rutas de procesos
 * - assetsRoutes: Rutas de activos
 * - securityRoutes: Rutas de seguridad y salud
 * - configRoutes: Rutas de configuración (matriz ACL)
 * - adminRoutes: Rutas de administración (matriz ACL)
 */

import { publicRoutes } from './public.jsx'
import { generalRoutes } from './general.jsx'
import { productionRoutes } from './production.jsx'
import { qualityRoutes } from './quality.jsx'
import { personasRoutes } from './personas.jsx'
import { processesRoutes } from './processes.jsx'
import { assetsRoutes } from './assets.jsx'
import { securityRoutes } from './security.jsx'
import { configRoutes } from './config.jsx'
import { maintenanceRoutes } from './maintenance.jsx'
import { adminRoutes } from './admin.jsx'
import { validateRouteAccessCoverage } from '../utils/routeAccess'

/**
 * Exportar rutas públicas para uso en App.jsx
 */
export { publicRoutes }

/**
 * Todas las rutas de la aplicación
 * Se exportan como un array plano para facilitar su uso en App.jsx
 */
export const allRoutes = [
  ...publicRoutes,
  ...generalRoutes,
  ...productionRoutes,
  ...qualityRoutes,
  ...personasRoutes,
  ...processesRoutes,
  ...assetsRoutes,
  ...securityRoutes,
  ...configRoutes,
  ...adminRoutes,
  ...maintenanceRoutes,
]

/**
 * Rutas agrupadas por módulo (útil para debugging y validación)
 */
export const routesByModule = {
  public: publicRoutes,
  general: generalRoutes,
  production: productionRoutes,
  quality: qualityRoutes,
  personas: personasRoutes,
  processes: processesRoutes,
  assets: assetsRoutes,
  security: securityRoutes,
  config: configRoutes,
  admin: adminRoutes,
  maintenance: maintenanceRoutes,
}

/**
 * Validación de rutas
 * Verifica que todas las rutas tengan las propiedades requeridas
 */
export function validateRoutes() {
  const errors = []
  
  allRoutes.forEach((route, index) => {
    if (!route.props.path) {
      errors.push(`Ruta en índice ${index} no tiene propiedad 'path'`)
    }
    if (!route.props.element) {
      errors.push(`Ruta '${route.props.path}' no tiene propiedad 'element'`)
    }
  })
  
  const aclErrors = validateRouteAccessCoverage(allRoutes)
  errors.push(...aclErrors)

  if (errors.length > 0) {
    console.error('❌ Errores de validación de rutas:', errors)
    return false
  }

  console.log(`✅ Validación de rutas exitosa: ${allRoutes.length} rutas registradas`)
  return true
}

